// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: calendar.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "familyos.v1";

/**
 * Family OS — Calendar events and sync connections.
 *
 * See common.proto for design notes.
 */

export interface CalendarEventDelta {
  server_id: string;
  client_local_id: string;
  action: CalendarEventDelta_Action;
  event?: CalendarEvent | undefined;
  client_updated_at?: string | undefined;
}

export enum CalendarEventDelta_Action {
  ACTION_UNSPECIFIED = 0,
  ACTION_UPSERT = 1,
  ACTION_DELETE = 2,
  UNRECOGNIZED = -1,
}

export function calendarEventDelta_ActionFromJSON(object: any): CalendarEventDelta_Action {
  switch (object) {
    case 0:
    case "ACTION_UNSPECIFIED":
      return CalendarEventDelta_Action.ACTION_UNSPECIFIED;
    case 1:
    case "ACTION_UPSERT":
      return CalendarEventDelta_Action.ACTION_UPSERT;
    case 2:
    case "ACTION_DELETE":
      return CalendarEventDelta_Action.ACTION_DELETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CalendarEventDelta_Action.UNRECOGNIZED;
  }
}

export function calendarEventDelta_ActionToJSON(object: CalendarEventDelta_Action): string {
  switch (object) {
    case CalendarEventDelta_Action.ACTION_UNSPECIFIED:
      return "ACTION_UNSPECIFIED";
    case CalendarEventDelta_Action.ACTION_UPSERT:
      return "ACTION_UPSERT";
    case CalendarEventDelta_Action.ACTION_DELETE:
      return "ACTION_DELETE";
    case CalendarEventDelta_Action.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CalendarSyncPushRequest {
  deltas: CalendarEventDelta[];
}

export interface CalendarSyncPushResponse {
  mappings: CalendarSyncPushResponse_IdMapping[];
  rejected_client_ids: string[];
}

export interface CalendarSyncPushResponse_IdMapping {
  client_local_id: string;
  server_id: string;
}

export interface CalendarSyncPullRequest {
  since?: string | undefined;
  limit: number;
  /**
   * When true, force the server to re-expand and emit the recurrence
   * virtuals regardless of whether any recurring todo changed since the
   * cursor. The client sets this on first sync (empty cursor) and once per
   * day (last-materialize date != today, checked at pull time) so the
   * forward window's far edge materializes and the stale head drops.
   * Otherwise virtuals are emitted only when a recurring todo changed since
   * `since` (the EXISTS gate), so a no-change same-day pull does zero
   * calendar work.
   */
  materialize_window: boolean;
  /**
   * Client capability flag: true means the client understands the
   * conditional-emission protocol (it reads CalendarSyncPullResponse.
   * virtuals_included and only wipes + reapplies its in-window
   * recurrence virtuals when that flag is set). The server applies the
   * change/materialize gate ONLY for such clients.
   *
   * Old clients (pre-PERF-F) never set this — they wipe their in-window
   * virtuals UNCONDITIONALLY every pull and expect the server to always
   * re-send all in-window virtuals. proto3 can't distinguish an old
   * client's absent materialize_window from a new client's false, so the
   * server keys off this explicit capability bit: when false (old client)
   * it emits virtuals on EVERY pull (preserving the legacy wholesale
   * behavior); when true (new client) it gates emission.
   */
  gated_virtuals: boolean;
}

export interface CalendarSyncPullResponse {
  /**
   * Includes soft-deleted rows (real tombstones) and redaction tombstones
   * — events the caller cannot see arrive with id + deleted_at set and
   * every other field zeroed, mirroring the todo pull.
   */
  events: CalendarEvent[];
  cursor?: string | undefined;
  has_more: boolean;
  /**
   * True when this response carried the (re-expanded) recurrence virtuals
   * — i.e. the gate fired (materialize_window or a recurring todo changed
   * since the cursor). The client wipes + reapplies the in-window
   * provider="recurrence" rows ONLY when this is true; when false it leaves
   * all in-window virtuals untouched (zero calendar writes).
   */
  virtuals_included: boolean;
}

/**
 * CalendarConnectionDelta carries the post-write state of a single
 * CalDAV / Google sync run so the client can project mutations onto
 * its calendar.events slice directly instead of refetching the full
 * event list. Returned inline from the sync RPCs. Per
 * feedback_saga_full_delta: the response IS the delta; the saga
 * dispatches one Redux action per mutated row.
 */
export interface CalendarConnectionDelta {
  connection_id: string;
  /** Events newly created by this sync run. */
  created_events: CalendarEvent[];
  /** Events whose fields changed during this sync run. */
  updated_events: CalendarEvent[];
  /**
   * Server ids of events removed from the connection (e.g. dropped
   * from the remote calendar, or wiped because a subcalendar got
   * disabled). Includes both hard deletes and tombstones — the
   * client treats both the same way: remove from cache.
   */
  deleted_event_ids: string[];
  /**
   * Connection-level fields after the sync. Optional — omitted when
   * the handler doesn't have a fresh value (e.g. legacy code paths
   * that don't touch last_synced_at).
   */
  last_synced_at?: string | undefined;
  status?: string | undefined;
}

export interface CalendarEvent {
  id: string;
  title: string;
  description?: string | undefined;
  owner_id: string;
  start_time?: string | undefined;
  end_time?: string | undefined;
  all_day: boolean;
  location?: string | undefined;
  provider: string;
  external_id?: string | undefined;
  household_id?: string | undefined;
  todo_id?:
    | string
    | undefined;
  /** Empty string when this event is a one-off. */
  recurrence_freq: string;
  created_at?: string | undefined;
  updated_at?:
    | string
    | undefined;
  /**
   * "public" (default) or "private". Mirrors Todo.visibility — private
   * events are only visible to (and only mutable by) the current owner_id.
   */
  visibility: string;
  /**
   * Soft-delete marker. Set on deleted rows so iOS sync can apply
   * tombstones; absent on live rows. Mirrors Todo.deleted_at.
   */
  deleted_at?:
    | string
    | undefined;
  /**
   * FK to the calendar_subcalendar row this event belongs to. Set at
   * sync time for Apple/Google rows; null for manual events.
   */
  subcalendar_id?:
    | string
    | undefined;
  /**
   * Hex color override pulled from the subcalendar (e.g. "#ff5500").
   * Empty string when the subcalendar has no override — clients fall
   * back to the per-owner palette color.
   */
  color?:
    | string
    | undefined;
  /**
   * Human-readable subcalendar name (e.g. "Work" for a Google
   * calendar named that). Denormalized at read time so clients can
   * render "google > Work" without a separate lookup. Empty when the
   * event has no subcalendar link.
   */
  subcalendar_name?:
    | string
    | undefined;
  /**
   * Display-only attribution: when set, this event belongs to the
   * importer (owner_id) but family view renders it under this
   * assigned member. Solo views of either user hide the event —
   * it lives only in family view. Denormalized from the parent
   * subcalendar at read time.
   */
  assigned_owner_id?: string | undefined;
}

export interface CalendarConnection {
  id: string;
  provider: string;
  status: string;
  last_synced_at?: string | undefined;
  calendar_name?:
    | string
    | undefined;
  /** Populated for some providers (Google, Apple). */
  email?:
    | string
    | undefined;
  /** Optional: "import" | "export" | "bidirectional" */
  direction?:
    | string
    | undefined;
  /** Apple subcalendars selected for sync. Empty = all discovered calendars. */
  selected_calendar_uris: string[];
  /** Google subcalendars selected for sync. Empty = primary only. */
  selected_google_calendar_ids: string[];
}

export interface CalendarListResponse {
  calendars: CalendarConnection[];
}

export interface CalendarEventListResponse {
  events: CalendarEvent[];
}

export interface CreateCalendarEventRequest {
  title: string;
  start_time?: string | undefined;
  end_time?: string | undefined;
  description?: string | undefined;
  location?: string | undefined;
  all_day?: boolean | undefined;
  recurrence_freq?:
    | string
    | undefined;
  /** "public" (default) or "private". Mirrors Todo.visibility. */
  visibility?: string | undefined;
}

export interface CalendarSyncRequest {
  provider: string;
  email?: string | undefined;
}

export interface CalendarSyncResponse {
  authorization_url?: string | undefined;
  state_token?: string | undefined;
}

export interface GoogleAuthInitResponse {
  auth_url: string;
  /**
   * Server-side OAuth state token. Client must echo it back via the
   * ?state= query param on the callback URL so the server can correlate
   * the callback to the originating user.
   */
  state: string;
}

export interface ListCalendarEventsRequest {
  start?: string | undefined;
  end?: string | undefined;
}

export interface GoogleCalendarAuthRequest {
  /** Where to redirect the user after Google completes consent. Required. */
  redirect_url: string;
}

export interface GoogleCalendarCallbackRequest {
  code: string;
  state: string;
}

export interface GoogleAuthCallbackResponse {
  access_token: string;
  expiry?: string | undefined;
}

export interface GoogleCalendarSyncResponse {
  inserted: number;
  updated: number;
  deleted: number;
  /**
   * Per-event delta carrying the actual rows mutated by this sync run.
   * Sagas project this onto the client calendar.events slice instead
   * of refetching the entire list (feedback_saga_full_delta).
   */
  delta?: CalendarConnectionDelta | undefined;
}

export interface CalendarDisconnectResponse {
  disconnected: boolean;
}

export interface ConvertCalendarEventToTodoRequest {
  id: string;
}

export interface AppleCalendarSetupRequest {
  provider: string;
  email: string;
  app_specific_password: string;
}

export interface AppleCalendarDiscoveredCalendar {
  name: string;
  uri: string;
}

export interface AppleCalendarSetupResponse {
  discovery_url: string;
  calendars: AppleCalendarDiscoveredCalendar[];
}

export interface AppleCalendarConnectionRequest {
  provider: string;
  email: string;
  app_specific_password: string;
  /**
   * Legacy single-calendar field. Prefer selected_calendar_uris below;
   * when both are set, selected_calendar_uris wins.
   */
  calendar_uri: string;
  direction?:
    | string
    | undefined;
  /** Multi-calendar selection. Empty means "all discovered calendars". */
  selected_calendar_uris: string[];
}

export interface AppleCalendarConnectionResponse {
  id: string;
  provider: string;
  email: string;
  status: string;
}

export interface CalendarConnectionListResponse {
  connections: CalendarConnection[];
}

export interface AppleCalendarManualSyncRequest {
  id: string;
}

export interface AppleCalendarSyncResponse {
  status: string;
  inserted: number;
  updated: number;
  deleted: number;
  last_sync: string;
  /**
   * Per-event delta carrying the actual rows mutated by this sync run.
   * Sagas project this onto the client calendar.events slice instead
   * of refetching the entire list (feedback_saga_full_delta).
   */
  delta?: CalendarConnectionDelta | undefined;
}

export interface AppleCalendarDisconnectRequest {
  id: string;
}

export interface GoogleCalendarWebhookRequest {
  /** Opaque payload — passed through to the webhook signature validator. */
  payload: string;
}

export interface GoogleCalendarWebhookResponse {
  status: string;
}

export interface GoogleCalendar {
  id: string;
  summary: string;
  primary: boolean;
  background_color?: string | undefined;
}

export interface GoogleCalendarListResponse {
  items: GoogleCalendar[];
}

export interface UpdateCalendarConnectionSelectionRequest {
  id: string;
  /** Calendar URIs (Apple) or calendar IDs (Google). Empty means "all". */
  selected_ids: string[];
}

/**
 * Subcalendar represents one discovered Apple/Google subcalendar with
 * its per-row enable / color / assigned-owner state.
 */
export interface Subcalendar {
  id: string;
  connection_id: string;
  provider: string;
  external_id: string;
  display_name: string;
  /**
   * Optional hex color (#rrggbb). Empty string means "use the
   * assigned owner's palette color".
   */
  color: string;
  enabled: boolean;
  /**
   * Optional: when set, events from this subcalendar are filed under
   * this household member (their family-view rows). Empty string =
   * default to the connection's owner.
   */
  assigned_owner_id: string;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

export interface ListSubcalendarsRequest {
  connection_id: string;
}

export interface SubcalendarListResponse {
  subcalendars: Subcalendar[];
}

/**
 * Optional fields for partial update — clients send only the keys
 * they want to change. Empty-string values for color and
 * assigned_owner_id are interpreted as "clear", but a missing field
 * means "leave unchanged" — the proto3 optional/has-bit semantics
 * distinguish the two.
 */
export interface UpdateSubcalendarRequest {
  id: string;
  enabled?: boolean | undefined;
  color?: string | undefined;
  assigned_owner_id?: string | undefined;
}

function createBaseCalendarEventDelta(): CalendarEventDelta {
  return { server_id: "", client_local_id: "", action: 0, event: undefined, client_updated_at: undefined };
}

export const CalendarEventDelta: MessageFns<CalendarEventDelta> = {
  encode(message: CalendarEventDelta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.server_id !== "") {
      writer.uint32(10).string(message.server_id);
    }
    if (message.client_local_id !== "") {
      writer.uint32(18).string(message.client_local_id);
    }
    if (message.action !== 0) {
      writer.uint32(24).int32(message.action);
    }
    if (message.event !== undefined) {
      CalendarEvent.encode(message.event, writer.uint32(34).fork()).join();
    }
    if (message.client_updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.client_updated_at), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarEventDelta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarEventDelta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.server_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.client_local_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.action = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.event = CalendarEvent.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.client_updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarEventDelta {
    return {
      server_id: isSet(object.server_id) ? globalThis.String(object.server_id) : "",
      client_local_id: isSet(object.client_local_id) ? globalThis.String(object.client_local_id) : "",
      action: isSet(object.action) ? calendarEventDelta_ActionFromJSON(object.action) : 0,
      event: isSet(object.event) ? CalendarEvent.fromJSON(object.event) : undefined,
      client_updated_at: isSet(object.client_updated_at) ? globalThis.String(object.client_updated_at) : undefined,
    };
  },

  toJSON(message: CalendarEventDelta): unknown {
    const obj: any = {};
    if (message.server_id !== "") {
      obj.server_id = message.server_id;
    }
    if (message.client_local_id !== "") {
      obj.client_local_id = message.client_local_id;
    }
    if (message.action !== 0) {
      obj.action = calendarEventDelta_ActionToJSON(message.action);
    }
    if (message.event !== undefined) {
      obj.event = CalendarEvent.toJSON(message.event);
    }
    if (message.client_updated_at !== undefined) {
      obj.client_updated_at = message.client_updated_at;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarEventDelta>): CalendarEventDelta {
    return CalendarEventDelta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarEventDelta>): CalendarEventDelta {
    const message = createBaseCalendarEventDelta();
    message.server_id = object.server_id ?? "";
    message.client_local_id = object.client_local_id ?? "";
    message.action = object.action ?? 0;
    message.event = (object.event !== undefined && object.event !== null)
      ? CalendarEvent.fromPartial(object.event)
      : undefined;
    message.client_updated_at = object.client_updated_at ?? undefined;
    return message;
  },
};

function createBaseCalendarSyncPushRequest(): CalendarSyncPushRequest {
  return { deltas: [] };
}

export const CalendarSyncPushRequest: MessageFns<CalendarSyncPushRequest> = {
  encode(message: CalendarSyncPushRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.deltas) {
      CalendarEventDelta.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarSyncPushRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarSyncPushRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deltas.push(CalendarEventDelta.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarSyncPushRequest {
    return {
      deltas: globalThis.Array.isArray(object?.deltas)
        ? object.deltas.map((e: any) => CalendarEventDelta.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CalendarSyncPushRequest): unknown {
    const obj: any = {};
    if (message.deltas?.length) {
      obj.deltas = message.deltas.map((e) => CalendarEventDelta.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarSyncPushRequest>): CalendarSyncPushRequest {
    return CalendarSyncPushRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarSyncPushRequest>): CalendarSyncPushRequest {
    const message = createBaseCalendarSyncPushRequest();
    message.deltas = object.deltas?.map((e) => CalendarEventDelta.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCalendarSyncPushResponse(): CalendarSyncPushResponse {
  return { mappings: [], rejected_client_ids: [] };
}

export const CalendarSyncPushResponse: MessageFns<CalendarSyncPushResponse> = {
  encode(message: CalendarSyncPushResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.mappings) {
      CalendarSyncPushResponse_IdMapping.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.rejected_client_ids) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarSyncPushResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarSyncPushResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mappings.push(CalendarSyncPushResponse_IdMapping.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rejected_client_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarSyncPushResponse {
    return {
      mappings: globalThis.Array.isArray(object?.mappings)
        ? object.mappings.map((e: any) => CalendarSyncPushResponse_IdMapping.fromJSON(e))
        : [],
      rejected_client_ids: globalThis.Array.isArray(object?.rejected_client_ids)
        ? object.rejected_client_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: CalendarSyncPushResponse): unknown {
    const obj: any = {};
    if (message.mappings?.length) {
      obj.mappings = message.mappings.map((e) => CalendarSyncPushResponse_IdMapping.toJSON(e));
    }
    if (message.rejected_client_ids?.length) {
      obj.rejected_client_ids = message.rejected_client_ids;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarSyncPushResponse>): CalendarSyncPushResponse {
    return CalendarSyncPushResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarSyncPushResponse>): CalendarSyncPushResponse {
    const message = createBaseCalendarSyncPushResponse();
    message.mappings = object.mappings?.map((e) => CalendarSyncPushResponse_IdMapping.fromPartial(e)) || [];
    message.rejected_client_ids = object.rejected_client_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseCalendarSyncPushResponse_IdMapping(): CalendarSyncPushResponse_IdMapping {
  return { client_local_id: "", server_id: "" };
}

export const CalendarSyncPushResponse_IdMapping: MessageFns<CalendarSyncPushResponse_IdMapping> = {
  encode(message: CalendarSyncPushResponse_IdMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.client_local_id !== "") {
      writer.uint32(10).string(message.client_local_id);
    }
    if (message.server_id !== "") {
      writer.uint32(18).string(message.server_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarSyncPushResponse_IdMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarSyncPushResponse_IdMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.client_local_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.server_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarSyncPushResponse_IdMapping {
    return {
      client_local_id: isSet(object.client_local_id) ? globalThis.String(object.client_local_id) : "",
      server_id: isSet(object.server_id) ? globalThis.String(object.server_id) : "",
    };
  },

  toJSON(message: CalendarSyncPushResponse_IdMapping): unknown {
    const obj: any = {};
    if (message.client_local_id !== "") {
      obj.client_local_id = message.client_local_id;
    }
    if (message.server_id !== "") {
      obj.server_id = message.server_id;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarSyncPushResponse_IdMapping>): CalendarSyncPushResponse_IdMapping {
    return CalendarSyncPushResponse_IdMapping.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarSyncPushResponse_IdMapping>): CalendarSyncPushResponse_IdMapping {
    const message = createBaseCalendarSyncPushResponse_IdMapping();
    message.client_local_id = object.client_local_id ?? "";
    message.server_id = object.server_id ?? "";
    return message;
  },
};

function createBaseCalendarSyncPullRequest(): CalendarSyncPullRequest {
  return { since: undefined, limit: 0, materialize_window: false, gated_virtuals: false };
}

export const CalendarSyncPullRequest: MessageFns<CalendarSyncPullRequest> = {
  encode(message: CalendarSyncPullRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.since !== undefined) {
      Timestamp.encode(toTimestamp(message.since), writer.uint32(10).fork()).join();
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    if (message.materialize_window !== false) {
      writer.uint32(24).bool(message.materialize_window);
    }
    if (message.gated_virtuals !== false) {
      writer.uint32(32).bool(message.gated_virtuals);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarSyncPullRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarSyncPullRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.since = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.materialize_window = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.gated_virtuals = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarSyncPullRequest {
    return {
      since: isSet(object.since) ? globalThis.String(object.since) : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      materialize_window: isSet(object.materialize_window) ? globalThis.Boolean(object.materialize_window) : false,
      gated_virtuals: isSet(object.gated_virtuals) ? globalThis.Boolean(object.gated_virtuals) : false,
    };
  },

  toJSON(message: CalendarSyncPullRequest): unknown {
    const obj: any = {};
    if (message.since !== undefined) {
      obj.since = message.since;
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.materialize_window !== false) {
      obj.materialize_window = message.materialize_window;
    }
    if (message.gated_virtuals !== false) {
      obj.gated_virtuals = message.gated_virtuals;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarSyncPullRequest>): CalendarSyncPullRequest {
    return CalendarSyncPullRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarSyncPullRequest>): CalendarSyncPullRequest {
    const message = createBaseCalendarSyncPullRequest();
    message.since = object.since ?? undefined;
    message.limit = object.limit ?? 0;
    message.materialize_window = object.materialize_window ?? false;
    message.gated_virtuals = object.gated_virtuals ?? false;
    return message;
  },
};

function createBaseCalendarSyncPullResponse(): CalendarSyncPullResponse {
  return { events: [], cursor: undefined, has_more: false, virtuals_included: false };
}

export const CalendarSyncPullResponse: MessageFns<CalendarSyncPullResponse> = {
  encode(message: CalendarSyncPullResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      CalendarEvent.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== undefined) {
      Timestamp.encode(toTimestamp(message.cursor), writer.uint32(18).fork()).join();
    }
    if (message.has_more !== false) {
      writer.uint32(24).bool(message.has_more);
    }
    if (message.virtuals_included !== false) {
      writer.uint32(32).bool(message.virtuals_included);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarSyncPullResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarSyncPullResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.events.push(CalendarEvent.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.has_more = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.virtuals_included = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarSyncPullResponse {
    return {
      events: globalThis.Array.isArray(object?.events) ? object.events.map((e: any) => CalendarEvent.fromJSON(e)) : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : undefined,
      has_more: isSet(object.has_more) ? globalThis.Boolean(object.has_more) : false,
      virtuals_included: isSet(object.virtuals_included) ? globalThis.Boolean(object.virtuals_included) : false,
    };
  },

  toJSON(message: CalendarSyncPullResponse): unknown {
    const obj: any = {};
    if (message.events?.length) {
      obj.events = message.events.map((e) => CalendarEvent.toJSON(e));
    }
    if (message.cursor !== undefined) {
      obj.cursor = message.cursor;
    }
    if (message.has_more !== false) {
      obj.has_more = message.has_more;
    }
    if (message.virtuals_included !== false) {
      obj.virtuals_included = message.virtuals_included;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarSyncPullResponse>): CalendarSyncPullResponse {
    return CalendarSyncPullResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarSyncPullResponse>): CalendarSyncPullResponse {
    const message = createBaseCalendarSyncPullResponse();
    message.events = object.events?.map((e) => CalendarEvent.fromPartial(e)) || [];
    message.cursor = object.cursor ?? undefined;
    message.has_more = object.has_more ?? false;
    message.virtuals_included = object.virtuals_included ?? false;
    return message;
  },
};

function createBaseCalendarConnectionDelta(): CalendarConnectionDelta {
  return {
    connection_id: "",
    created_events: [],
    updated_events: [],
    deleted_event_ids: [],
    last_synced_at: undefined,
    status: undefined,
  };
}

export const CalendarConnectionDelta: MessageFns<CalendarConnectionDelta> = {
  encode(message: CalendarConnectionDelta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.connection_id !== "") {
      writer.uint32(10).string(message.connection_id);
    }
    for (const v of message.created_events) {
      CalendarEvent.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.updated_events) {
      CalendarEvent.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.deleted_event_ids) {
      writer.uint32(34).string(v!);
    }
    if (message.last_synced_at !== undefined) {
      writer.uint32(42).string(message.last_synced_at);
    }
    if (message.status !== undefined) {
      writer.uint32(50).string(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarConnectionDelta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarConnectionDelta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.connection_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.created_events.push(CalendarEvent.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updated_events.push(CalendarEvent.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deleted_event_ids.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.last_synced_at = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.status = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarConnectionDelta {
    return {
      connection_id: isSet(object.connection_id) ? globalThis.String(object.connection_id) : "",
      created_events: globalThis.Array.isArray(object?.created_events)
        ? object.created_events.map((e: any) => CalendarEvent.fromJSON(e))
        : [],
      updated_events: globalThis.Array.isArray(object?.updated_events)
        ? object.updated_events.map((e: any) => CalendarEvent.fromJSON(e))
        : [],
      deleted_event_ids: globalThis.Array.isArray(object?.deleted_event_ids)
        ? object.deleted_event_ids.map((e: any) => globalThis.String(e))
        : [],
      last_synced_at: isSet(object.last_synced_at) ? globalThis.String(object.last_synced_at) : undefined,
      status: isSet(object.status) ? globalThis.String(object.status) : undefined,
    };
  },

  toJSON(message: CalendarConnectionDelta): unknown {
    const obj: any = {};
    if (message.connection_id !== "") {
      obj.connection_id = message.connection_id;
    }
    if (message.created_events?.length) {
      obj.created_events = message.created_events.map((e) => CalendarEvent.toJSON(e));
    }
    if (message.updated_events?.length) {
      obj.updated_events = message.updated_events.map((e) => CalendarEvent.toJSON(e));
    }
    if (message.deleted_event_ids?.length) {
      obj.deleted_event_ids = message.deleted_event_ids;
    }
    if (message.last_synced_at !== undefined) {
      obj.last_synced_at = message.last_synced_at;
    }
    if (message.status !== undefined) {
      obj.status = message.status;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarConnectionDelta>): CalendarConnectionDelta {
    return CalendarConnectionDelta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarConnectionDelta>): CalendarConnectionDelta {
    const message = createBaseCalendarConnectionDelta();
    message.connection_id = object.connection_id ?? "";
    message.created_events = object.created_events?.map((e) => CalendarEvent.fromPartial(e)) || [];
    message.updated_events = object.updated_events?.map((e) => CalendarEvent.fromPartial(e)) || [];
    message.deleted_event_ids = object.deleted_event_ids?.map((e) => e) || [];
    message.last_synced_at = object.last_synced_at ?? undefined;
    message.status = object.status ?? undefined;
    return message;
  },
};

function createBaseCalendarEvent(): CalendarEvent {
  return {
    id: "",
    title: "",
    description: undefined,
    owner_id: "",
    start_time: undefined,
    end_time: undefined,
    all_day: false,
    location: undefined,
    provider: "",
    external_id: undefined,
    household_id: undefined,
    todo_id: undefined,
    recurrence_freq: "",
    created_at: undefined,
    updated_at: undefined,
    visibility: "",
    deleted_at: undefined,
    subcalendar_id: undefined,
    color: undefined,
    subcalendar_name: undefined,
    assigned_owner_id: undefined,
  };
}

export const CalendarEvent: MessageFns<CalendarEvent> = {
  encode(message: CalendarEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.owner_id !== "") {
      writer.uint32(34).string(message.owner_id);
    }
    if (message.start_time !== undefined) {
      Timestamp.encode(toTimestamp(message.start_time), writer.uint32(42).fork()).join();
    }
    if (message.end_time !== undefined) {
      Timestamp.encode(toTimestamp(message.end_time), writer.uint32(50).fork()).join();
    }
    if (message.all_day !== false) {
      writer.uint32(56).bool(message.all_day);
    }
    if (message.location !== undefined) {
      writer.uint32(66).string(message.location);
    }
    if (message.provider !== "") {
      writer.uint32(74).string(message.provider);
    }
    if (message.external_id !== undefined) {
      writer.uint32(82).string(message.external_id);
    }
    if (message.household_id !== undefined) {
      writer.uint32(90).string(message.household_id);
    }
    if (message.todo_id !== undefined) {
      writer.uint32(98).string(message.todo_id);
    }
    if (message.recurrence_freq !== "") {
      writer.uint32(106).string(message.recurrence_freq);
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(114).fork()).join();
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(122).fork()).join();
    }
    if (message.visibility !== "") {
      writer.uint32(130).string(message.visibility);
    }
    if (message.deleted_at !== undefined) {
      Timestamp.encode(toTimestamp(message.deleted_at), writer.uint32(138).fork()).join();
    }
    if (message.subcalendar_id !== undefined) {
      writer.uint32(146).string(message.subcalendar_id);
    }
    if (message.color !== undefined) {
      writer.uint32(154).string(message.color);
    }
    if (message.subcalendar_name !== undefined) {
      writer.uint32(162).string(message.subcalendar_name);
    }
    if (message.assigned_owner_id !== undefined) {
      writer.uint32(170).string(message.assigned_owner_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.owner_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.start_time = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.end_time = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.all_day = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.external_id = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.household_id = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.todo_id = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.recurrence_freq = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.visibility = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.deleted_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.subcalendar_id = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.color = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.subcalendar_name = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.assigned_owner_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarEvent {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      owner_id: isSet(object.owner_id) ? globalThis.String(object.owner_id) : "",
      start_time: isSet(object.start_time) ? globalThis.String(object.start_time) : undefined,
      end_time: isSet(object.end_time) ? globalThis.String(object.end_time) : undefined,
      all_day: isSet(object.all_day) ? globalThis.Boolean(object.all_day) : false,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      external_id: isSet(object.external_id) ? globalThis.String(object.external_id) : undefined,
      household_id: isSet(object.household_id) ? globalThis.String(object.household_id) : undefined,
      todo_id: isSet(object.todo_id) ? globalThis.String(object.todo_id) : undefined,
      recurrence_freq: isSet(object.recurrence_freq) ? globalThis.String(object.recurrence_freq) : "",
      created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : undefined,
      updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : undefined,
      visibility: isSet(object.visibility) ? globalThis.String(object.visibility) : "",
      deleted_at: isSet(object.deleted_at) ? globalThis.String(object.deleted_at) : undefined,
      subcalendar_id: isSet(object.subcalendar_id) ? globalThis.String(object.subcalendar_id) : undefined,
      color: isSet(object.color) ? globalThis.String(object.color) : undefined,
      subcalendar_name: isSet(object.subcalendar_name) ? globalThis.String(object.subcalendar_name) : undefined,
      assigned_owner_id: isSet(object.assigned_owner_id) ? globalThis.String(object.assigned_owner_id) : undefined,
    };
  },

  toJSON(message: CalendarEvent): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.owner_id !== "") {
      obj.owner_id = message.owner_id;
    }
    if (message.start_time !== undefined) {
      obj.start_time = message.start_time;
    }
    if (message.end_time !== undefined) {
      obj.end_time = message.end_time;
    }
    if (message.all_day !== false) {
      obj.all_day = message.all_day;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.external_id !== undefined) {
      obj.external_id = message.external_id;
    }
    if (message.household_id !== undefined) {
      obj.household_id = message.household_id;
    }
    if (message.todo_id !== undefined) {
      obj.todo_id = message.todo_id;
    }
    if (message.recurrence_freq !== "") {
      obj.recurrence_freq = message.recurrence_freq;
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at;
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at;
    }
    if (message.visibility !== "") {
      obj.visibility = message.visibility;
    }
    if (message.deleted_at !== undefined) {
      obj.deleted_at = message.deleted_at;
    }
    if (message.subcalendar_id !== undefined) {
      obj.subcalendar_id = message.subcalendar_id;
    }
    if (message.color !== undefined) {
      obj.color = message.color;
    }
    if (message.subcalendar_name !== undefined) {
      obj.subcalendar_name = message.subcalendar_name;
    }
    if (message.assigned_owner_id !== undefined) {
      obj.assigned_owner_id = message.assigned_owner_id;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarEvent>): CalendarEvent {
    return CalendarEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarEvent>): CalendarEvent {
    const message = createBaseCalendarEvent();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.description = object.description ?? undefined;
    message.owner_id = object.owner_id ?? "";
    message.start_time = object.start_time ?? undefined;
    message.end_time = object.end_time ?? undefined;
    message.all_day = object.all_day ?? false;
    message.location = object.location ?? undefined;
    message.provider = object.provider ?? "";
    message.external_id = object.external_id ?? undefined;
    message.household_id = object.household_id ?? undefined;
    message.todo_id = object.todo_id ?? undefined;
    message.recurrence_freq = object.recurrence_freq ?? "";
    message.created_at = object.created_at ?? undefined;
    message.updated_at = object.updated_at ?? undefined;
    message.visibility = object.visibility ?? "";
    message.deleted_at = object.deleted_at ?? undefined;
    message.subcalendar_id = object.subcalendar_id ?? undefined;
    message.color = object.color ?? undefined;
    message.subcalendar_name = object.subcalendar_name ?? undefined;
    message.assigned_owner_id = object.assigned_owner_id ?? undefined;
    return message;
  },
};

function createBaseCalendarConnection(): CalendarConnection {
  return {
    id: "",
    provider: "",
    status: "",
    last_synced_at: undefined,
    calendar_name: undefined,
    email: undefined,
    direction: undefined,
    selected_calendar_uris: [],
    selected_google_calendar_ids: [],
  };
}

export const CalendarConnection: MessageFns<CalendarConnection> = {
  encode(message: CalendarConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.status !== "") {
      writer.uint32(26).string(message.status);
    }
    if (message.last_synced_at !== undefined) {
      Timestamp.encode(toTimestamp(message.last_synced_at), writer.uint32(34).fork()).join();
    }
    if (message.calendar_name !== undefined) {
      writer.uint32(42).string(message.calendar_name);
    }
    if (message.email !== undefined) {
      writer.uint32(50).string(message.email);
    }
    if (message.direction !== undefined) {
      writer.uint32(58).string(message.direction);
    }
    for (const v of message.selected_calendar_uris) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.selected_google_calendar_ids) {
      writer.uint32(74).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.last_synced_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.calendar_name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.direction = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.selected_calendar_uris.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.selected_google_calendar_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarConnection {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      last_synced_at: isSet(object.last_synced_at) ? globalThis.String(object.last_synced_at) : undefined,
      calendar_name: isSet(object.calendar_name) ? globalThis.String(object.calendar_name) : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      direction: isSet(object.direction) ? globalThis.String(object.direction) : undefined,
      selected_calendar_uris: globalThis.Array.isArray(object?.selected_calendar_uris)
        ? object.selected_calendar_uris.map((e: any) => globalThis.String(e))
        : [],
      selected_google_calendar_ids: globalThis.Array.isArray(object?.selected_google_calendar_ids)
        ? object.selected_google_calendar_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: CalendarConnection): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.last_synced_at !== undefined) {
      obj.last_synced_at = message.last_synced_at;
    }
    if (message.calendar_name !== undefined) {
      obj.calendar_name = message.calendar_name;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.direction !== undefined) {
      obj.direction = message.direction;
    }
    if (message.selected_calendar_uris?.length) {
      obj.selected_calendar_uris = message.selected_calendar_uris;
    }
    if (message.selected_google_calendar_ids?.length) {
      obj.selected_google_calendar_ids = message.selected_google_calendar_ids;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarConnection>): CalendarConnection {
    return CalendarConnection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarConnection>): CalendarConnection {
    const message = createBaseCalendarConnection();
    message.id = object.id ?? "";
    message.provider = object.provider ?? "";
    message.status = object.status ?? "";
    message.last_synced_at = object.last_synced_at ?? undefined;
    message.calendar_name = object.calendar_name ?? undefined;
    message.email = object.email ?? undefined;
    message.direction = object.direction ?? undefined;
    message.selected_calendar_uris = object.selected_calendar_uris?.map((e) => e) || [];
    message.selected_google_calendar_ids = object.selected_google_calendar_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseCalendarListResponse(): CalendarListResponse {
  return { calendars: [] };
}

export const CalendarListResponse: MessageFns<CalendarListResponse> = {
  encode(message: CalendarListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.calendars) {
      CalendarConnection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.calendars.push(CalendarConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarListResponse {
    return {
      calendars: globalThis.Array.isArray(object?.calendars)
        ? object.calendars.map((e: any) => CalendarConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CalendarListResponse): unknown {
    const obj: any = {};
    if (message.calendars?.length) {
      obj.calendars = message.calendars.map((e) => CalendarConnection.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarListResponse>): CalendarListResponse {
    return CalendarListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarListResponse>): CalendarListResponse {
    const message = createBaseCalendarListResponse();
    message.calendars = object.calendars?.map((e) => CalendarConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCalendarEventListResponse(): CalendarEventListResponse {
  return { events: [] };
}

export const CalendarEventListResponse: MessageFns<CalendarEventListResponse> = {
  encode(message: CalendarEventListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      CalendarEvent.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarEventListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarEventListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.events.push(CalendarEvent.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarEventListResponse {
    return {
      events: globalThis.Array.isArray(object?.events) ? object.events.map((e: any) => CalendarEvent.fromJSON(e)) : [],
    };
  },

  toJSON(message: CalendarEventListResponse): unknown {
    const obj: any = {};
    if (message.events?.length) {
      obj.events = message.events.map((e) => CalendarEvent.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarEventListResponse>): CalendarEventListResponse {
    return CalendarEventListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarEventListResponse>): CalendarEventListResponse {
    const message = createBaseCalendarEventListResponse();
    message.events = object.events?.map((e) => CalendarEvent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateCalendarEventRequest(): CreateCalendarEventRequest {
  return {
    title: "",
    start_time: undefined,
    end_time: undefined,
    description: undefined,
    location: undefined,
    all_day: undefined,
    recurrence_freq: undefined,
    visibility: undefined,
  };
}

export const CreateCalendarEventRequest: MessageFns<CreateCalendarEventRequest> = {
  encode(message: CreateCalendarEventRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.start_time !== undefined) {
      Timestamp.encode(toTimestamp(message.start_time), writer.uint32(18).fork()).join();
    }
    if (message.end_time !== undefined) {
      Timestamp.encode(toTimestamp(message.end_time), writer.uint32(26).fork()).join();
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.location !== undefined) {
      writer.uint32(42).string(message.location);
    }
    if (message.all_day !== undefined) {
      writer.uint32(48).bool(message.all_day);
    }
    if (message.recurrence_freq !== undefined) {
      writer.uint32(58).string(message.recurrence_freq);
    }
    if (message.visibility !== undefined) {
      writer.uint32(66).string(message.visibility);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCalendarEventRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCalendarEventRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.start_time = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.end_time = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.all_day = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.recurrence_freq = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.visibility = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCalendarEventRequest {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      start_time: isSet(object.start_time) ? globalThis.String(object.start_time) : undefined,
      end_time: isSet(object.end_time) ? globalThis.String(object.end_time) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      location: isSet(object.location) ? globalThis.String(object.location) : undefined,
      all_day: isSet(object.all_day) ? globalThis.Boolean(object.all_day) : undefined,
      recurrence_freq: isSet(object.recurrence_freq) ? globalThis.String(object.recurrence_freq) : undefined,
      visibility: isSet(object.visibility) ? globalThis.String(object.visibility) : undefined,
    };
  },

  toJSON(message: CreateCalendarEventRequest): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.start_time !== undefined) {
      obj.start_time = message.start_time;
    }
    if (message.end_time !== undefined) {
      obj.end_time = message.end_time;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.location !== undefined) {
      obj.location = message.location;
    }
    if (message.all_day !== undefined) {
      obj.all_day = message.all_day;
    }
    if (message.recurrence_freq !== undefined) {
      obj.recurrence_freq = message.recurrence_freq;
    }
    if (message.visibility !== undefined) {
      obj.visibility = message.visibility;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateCalendarEventRequest>): CreateCalendarEventRequest {
    return CreateCalendarEventRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateCalendarEventRequest>): CreateCalendarEventRequest {
    const message = createBaseCreateCalendarEventRequest();
    message.title = object.title ?? "";
    message.start_time = object.start_time ?? undefined;
    message.end_time = object.end_time ?? undefined;
    message.description = object.description ?? undefined;
    message.location = object.location ?? undefined;
    message.all_day = object.all_day ?? undefined;
    message.recurrence_freq = object.recurrence_freq ?? undefined;
    message.visibility = object.visibility ?? undefined;
    return message;
  },
};

function createBaseCalendarSyncRequest(): CalendarSyncRequest {
  return { provider: "", email: undefined };
}

export const CalendarSyncRequest: MessageFns<CalendarSyncRequest> = {
  encode(message: CalendarSyncRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.email !== undefined) {
      writer.uint32(18).string(message.email);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarSyncRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarSyncRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarSyncRequest {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
    };
  },

  toJSON(message: CalendarSyncRequest): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarSyncRequest>): CalendarSyncRequest {
    return CalendarSyncRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarSyncRequest>): CalendarSyncRequest {
    const message = createBaseCalendarSyncRequest();
    message.provider = object.provider ?? "";
    message.email = object.email ?? undefined;
    return message;
  },
};

function createBaseCalendarSyncResponse(): CalendarSyncResponse {
  return { authorization_url: undefined, state_token: undefined };
}

export const CalendarSyncResponse: MessageFns<CalendarSyncResponse> = {
  encode(message: CalendarSyncResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.authorization_url !== undefined) {
      writer.uint32(10).string(message.authorization_url);
    }
    if (message.state_token !== undefined) {
      writer.uint32(18).string(message.state_token);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarSyncResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarSyncResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.authorization_url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state_token = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarSyncResponse {
    return {
      authorization_url: isSet(object.authorization_url) ? globalThis.String(object.authorization_url) : undefined,
      state_token: isSet(object.state_token) ? globalThis.String(object.state_token) : undefined,
    };
  },

  toJSON(message: CalendarSyncResponse): unknown {
    const obj: any = {};
    if (message.authorization_url !== undefined) {
      obj.authorization_url = message.authorization_url;
    }
    if (message.state_token !== undefined) {
      obj.state_token = message.state_token;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarSyncResponse>): CalendarSyncResponse {
    return CalendarSyncResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarSyncResponse>): CalendarSyncResponse {
    const message = createBaseCalendarSyncResponse();
    message.authorization_url = object.authorization_url ?? undefined;
    message.state_token = object.state_token ?? undefined;
    return message;
  },
};

function createBaseGoogleAuthInitResponse(): GoogleAuthInitResponse {
  return { auth_url: "", state: "" };
}

export const GoogleAuthInitResponse: MessageFns<GoogleAuthInitResponse> = {
  encode(message: GoogleAuthInitResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.auth_url !== "") {
      writer.uint32(10).string(message.auth_url);
    }
    if (message.state !== "") {
      writer.uint32(18).string(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleAuthInitResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleAuthInitResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.auth_url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleAuthInitResponse {
    return {
      auth_url: isSet(object.auth_url) ? globalThis.String(object.auth_url) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
    };
  },

  toJSON(message: GoogleAuthInitResponse): unknown {
    const obj: any = {};
    if (message.auth_url !== "") {
      obj.auth_url = message.auth_url;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleAuthInitResponse>): GoogleAuthInitResponse {
    return GoogleAuthInitResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleAuthInitResponse>): GoogleAuthInitResponse {
    const message = createBaseGoogleAuthInitResponse();
    message.auth_url = object.auth_url ?? "";
    message.state = object.state ?? "";
    return message;
  },
};

function createBaseListCalendarEventsRequest(): ListCalendarEventsRequest {
  return { start: undefined, end: undefined };
}

export const ListCalendarEventsRequest: MessageFns<ListCalendarEventsRequest> = {
  encode(message: ListCalendarEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== undefined) {
      Timestamp.encode(toTimestamp(message.start), writer.uint32(10).fork()).join();
    }
    if (message.end !== undefined) {
      Timestamp.encode(toTimestamp(message.end), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCalendarEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCalendarEventsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.start = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.end = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCalendarEventsRequest {
    return {
      start: isSet(object.start) ? globalThis.String(object.start) : undefined,
      end: isSet(object.end) ? globalThis.String(object.end) : undefined,
    };
  },

  toJSON(message: ListCalendarEventsRequest): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = message.start;
    }
    if (message.end !== undefined) {
      obj.end = message.end;
    }
    return obj;
  },

  create(base?: DeepPartial<ListCalendarEventsRequest>): ListCalendarEventsRequest {
    return ListCalendarEventsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListCalendarEventsRequest>): ListCalendarEventsRequest {
    const message = createBaseListCalendarEventsRequest();
    message.start = object.start ?? undefined;
    message.end = object.end ?? undefined;
    return message;
  },
};

function createBaseGoogleCalendarAuthRequest(): GoogleCalendarAuthRequest {
  return { redirect_url: "" };
}

export const GoogleCalendarAuthRequest: MessageFns<GoogleCalendarAuthRequest> = {
  encode(message: GoogleCalendarAuthRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.redirect_url !== "") {
      writer.uint32(10).string(message.redirect_url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleCalendarAuthRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleCalendarAuthRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.redirect_url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleCalendarAuthRequest {
    return { redirect_url: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : "" };
  },

  toJSON(message: GoogleCalendarAuthRequest): unknown {
    const obj: any = {};
    if (message.redirect_url !== "") {
      obj.redirect_url = message.redirect_url;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleCalendarAuthRequest>): GoogleCalendarAuthRequest {
    return GoogleCalendarAuthRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleCalendarAuthRequest>): GoogleCalendarAuthRequest {
    const message = createBaseGoogleCalendarAuthRequest();
    message.redirect_url = object.redirect_url ?? "";
    return message;
  },
};

function createBaseGoogleCalendarCallbackRequest(): GoogleCalendarCallbackRequest {
  return { code: "", state: "" };
}

export const GoogleCalendarCallbackRequest: MessageFns<GoogleCalendarCallbackRequest> = {
  encode(message: GoogleCalendarCallbackRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.state !== "") {
      writer.uint32(18).string(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleCalendarCallbackRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleCalendarCallbackRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleCalendarCallbackRequest {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
    };
  },

  toJSON(message: GoogleCalendarCallbackRequest): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleCalendarCallbackRequest>): GoogleCalendarCallbackRequest {
    return GoogleCalendarCallbackRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleCalendarCallbackRequest>): GoogleCalendarCallbackRequest {
    const message = createBaseGoogleCalendarCallbackRequest();
    message.code = object.code ?? "";
    message.state = object.state ?? "";
    return message;
  },
};

function createBaseGoogleAuthCallbackResponse(): GoogleAuthCallbackResponse {
  return { access_token: "", expiry: undefined };
}

export const GoogleAuthCallbackResponse: MessageFns<GoogleAuthCallbackResponse> = {
  encode(message: GoogleAuthCallbackResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.access_token !== "") {
      writer.uint32(10).string(message.access_token);
    }
    if (message.expiry !== undefined) {
      Timestamp.encode(toTimestamp(message.expiry), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleAuthCallbackResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleAuthCallbackResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.access_token = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.expiry = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleAuthCallbackResponse {
    return {
      access_token: isSet(object.access_token) ? globalThis.String(object.access_token) : "",
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : undefined,
    };
  },

  toJSON(message: GoogleAuthCallbackResponse): unknown {
    const obj: any = {};
    if (message.access_token !== "") {
      obj.access_token = message.access_token;
    }
    if (message.expiry !== undefined) {
      obj.expiry = message.expiry;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleAuthCallbackResponse>): GoogleAuthCallbackResponse {
    return GoogleAuthCallbackResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleAuthCallbackResponse>): GoogleAuthCallbackResponse {
    const message = createBaseGoogleAuthCallbackResponse();
    message.access_token = object.access_token ?? "";
    message.expiry = object.expiry ?? undefined;
    return message;
  },
};

function createBaseGoogleCalendarSyncResponse(): GoogleCalendarSyncResponse {
  return { inserted: 0, updated: 0, deleted: 0, delta: undefined };
}

export const GoogleCalendarSyncResponse: MessageFns<GoogleCalendarSyncResponse> = {
  encode(message: GoogleCalendarSyncResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inserted !== 0) {
      writer.uint32(8).int32(message.inserted);
    }
    if (message.updated !== 0) {
      writer.uint32(16).int32(message.updated);
    }
    if (message.deleted !== 0) {
      writer.uint32(24).int32(message.deleted);
    }
    if (message.delta !== undefined) {
      CalendarConnectionDelta.encode(message.delta, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleCalendarSyncResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleCalendarSyncResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.inserted = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.updated = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.deleted = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.delta = CalendarConnectionDelta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleCalendarSyncResponse {
    return {
      inserted: isSet(object.inserted) ? globalThis.Number(object.inserted) : 0,
      updated: isSet(object.updated) ? globalThis.Number(object.updated) : 0,
      deleted: isSet(object.deleted) ? globalThis.Number(object.deleted) : 0,
      delta: isSet(object.delta) ? CalendarConnectionDelta.fromJSON(object.delta) : undefined,
    };
  },

  toJSON(message: GoogleCalendarSyncResponse): unknown {
    const obj: any = {};
    if (message.inserted !== 0) {
      obj.inserted = Math.round(message.inserted);
    }
    if (message.updated !== 0) {
      obj.updated = Math.round(message.updated);
    }
    if (message.deleted !== 0) {
      obj.deleted = Math.round(message.deleted);
    }
    if (message.delta !== undefined) {
      obj.delta = CalendarConnectionDelta.toJSON(message.delta);
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleCalendarSyncResponse>): GoogleCalendarSyncResponse {
    return GoogleCalendarSyncResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleCalendarSyncResponse>): GoogleCalendarSyncResponse {
    const message = createBaseGoogleCalendarSyncResponse();
    message.inserted = object.inserted ?? 0;
    message.updated = object.updated ?? 0;
    message.deleted = object.deleted ?? 0;
    message.delta = (object.delta !== undefined && object.delta !== null)
      ? CalendarConnectionDelta.fromPartial(object.delta)
      : undefined;
    return message;
  },
};

function createBaseCalendarDisconnectResponse(): CalendarDisconnectResponse {
  return { disconnected: false };
}

export const CalendarDisconnectResponse: MessageFns<CalendarDisconnectResponse> = {
  encode(message: CalendarDisconnectResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.disconnected !== false) {
      writer.uint32(8).bool(message.disconnected);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarDisconnectResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarDisconnectResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.disconnected = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarDisconnectResponse {
    return { disconnected: isSet(object.disconnected) ? globalThis.Boolean(object.disconnected) : false };
  },

  toJSON(message: CalendarDisconnectResponse): unknown {
    const obj: any = {};
    if (message.disconnected !== false) {
      obj.disconnected = message.disconnected;
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarDisconnectResponse>): CalendarDisconnectResponse {
    return CalendarDisconnectResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarDisconnectResponse>): CalendarDisconnectResponse {
    const message = createBaseCalendarDisconnectResponse();
    message.disconnected = object.disconnected ?? false;
    return message;
  },
};

function createBaseConvertCalendarEventToTodoRequest(): ConvertCalendarEventToTodoRequest {
  return { id: "" };
}

export const ConvertCalendarEventToTodoRequest: MessageFns<ConvertCalendarEventToTodoRequest> = {
  encode(message: ConvertCalendarEventToTodoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConvertCalendarEventToTodoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConvertCalendarEventToTodoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConvertCalendarEventToTodoRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ConvertCalendarEventToTodoRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<ConvertCalendarEventToTodoRequest>): ConvertCalendarEventToTodoRequest {
    return ConvertCalendarEventToTodoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConvertCalendarEventToTodoRequest>): ConvertCalendarEventToTodoRequest {
    const message = createBaseConvertCalendarEventToTodoRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseAppleCalendarSetupRequest(): AppleCalendarSetupRequest {
  return { provider: "", email: "", app_specific_password: "" };
}

export const AppleCalendarSetupRequest: MessageFns<AppleCalendarSetupRequest> = {
  encode(message: AppleCalendarSetupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.app_specific_password !== "") {
      writer.uint32(26).string(message.app_specific_password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarSetupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarSetupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.app_specific_password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarSetupRequest {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      app_specific_password: isSet(object.app_specific_password) ? globalThis.String(object.app_specific_password) : "",
    };
  },

  toJSON(message: AppleCalendarSetupRequest): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.app_specific_password !== "") {
      obj.app_specific_password = message.app_specific_password;
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarSetupRequest>): AppleCalendarSetupRequest {
    return AppleCalendarSetupRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarSetupRequest>): AppleCalendarSetupRequest {
    const message = createBaseAppleCalendarSetupRequest();
    message.provider = object.provider ?? "";
    message.email = object.email ?? "";
    message.app_specific_password = object.app_specific_password ?? "";
    return message;
  },
};

function createBaseAppleCalendarDiscoveredCalendar(): AppleCalendarDiscoveredCalendar {
  return { name: "", uri: "" };
}

export const AppleCalendarDiscoveredCalendar: MessageFns<AppleCalendarDiscoveredCalendar> = {
  encode(message: AppleCalendarDiscoveredCalendar, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.uri !== "") {
      writer.uint32(18).string(message.uri);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarDiscoveredCalendar {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarDiscoveredCalendar();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uri = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarDiscoveredCalendar {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      uri: isSet(object.uri) ? globalThis.String(object.uri) : "",
    };
  },

  toJSON(message: AppleCalendarDiscoveredCalendar): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.uri !== "") {
      obj.uri = message.uri;
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarDiscoveredCalendar>): AppleCalendarDiscoveredCalendar {
    return AppleCalendarDiscoveredCalendar.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarDiscoveredCalendar>): AppleCalendarDiscoveredCalendar {
    const message = createBaseAppleCalendarDiscoveredCalendar();
    message.name = object.name ?? "";
    message.uri = object.uri ?? "";
    return message;
  },
};

function createBaseAppleCalendarSetupResponse(): AppleCalendarSetupResponse {
  return { discovery_url: "", calendars: [] };
}

export const AppleCalendarSetupResponse: MessageFns<AppleCalendarSetupResponse> = {
  encode(message: AppleCalendarSetupResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.discovery_url !== "") {
      writer.uint32(10).string(message.discovery_url);
    }
    for (const v of message.calendars) {
      AppleCalendarDiscoveredCalendar.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarSetupResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarSetupResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.discovery_url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.calendars.push(AppleCalendarDiscoveredCalendar.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarSetupResponse {
    return {
      discovery_url: isSet(object.discovery_url) ? globalThis.String(object.discovery_url) : "",
      calendars: globalThis.Array.isArray(object?.calendars)
        ? object.calendars.map((e: any) => AppleCalendarDiscoveredCalendar.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AppleCalendarSetupResponse): unknown {
    const obj: any = {};
    if (message.discovery_url !== "") {
      obj.discovery_url = message.discovery_url;
    }
    if (message.calendars?.length) {
      obj.calendars = message.calendars.map((e) => AppleCalendarDiscoveredCalendar.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarSetupResponse>): AppleCalendarSetupResponse {
    return AppleCalendarSetupResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarSetupResponse>): AppleCalendarSetupResponse {
    const message = createBaseAppleCalendarSetupResponse();
    message.discovery_url = object.discovery_url ?? "";
    message.calendars = object.calendars?.map((e) => AppleCalendarDiscoveredCalendar.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAppleCalendarConnectionRequest(): AppleCalendarConnectionRequest {
  return {
    provider: "",
    email: "",
    app_specific_password: "",
    calendar_uri: "",
    direction: undefined,
    selected_calendar_uris: [],
  };
}

export const AppleCalendarConnectionRequest: MessageFns<AppleCalendarConnectionRequest> = {
  encode(message: AppleCalendarConnectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.app_specific_password !== "") {
      writer.uint32(26).string(message.app_specific_password);
    }
    if (message.calendar_uri !== "") {
      writer.uint32(34).string(message.calendar_uri);
    }
    if (message.direction !== undefined) {
      writer.uint32(42).string(message.direction);
    }
    for (const v of message.selected_calendar_uris) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarConnectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarConnectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.app_specific_password = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.calendar_uri = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.direction = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.selected_calendar_uris.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarConnectionRequest {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      app_specific_password: isSet(object.app_specific_password) ? globalThis.String(object.app_specific_password) : "",
      calendar_uri: isSet(object.calendar_uri) ? globalThis.String(object.calendar_uri) : "",
      direction: isSet(object.direction) ? globalThis.String(object.direction) : undefined,
      selected_calendar_uris: globalThis.Array.isArray(object?.selected_calendar_uris)
        ? object.selected_calendar_uris.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: AppleCalendarConnectionRequest): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.app_specific_password !== "") {
      obj.app_specific_password = message.app_specific_password;
    }
    if (message.calendar_uri !== "") {
      obj.calendar_uri = message.calendar_uri;
    }
    if (message.direction !== undefined) {
      obj.direction = message.direction;
    }
    if (message.selected_calendar_uris?.length) {
      obj.selected_calendar_uris = message.selected_calendar_uris;
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarConnectionRequest>): AppleCalendarConnectionRequest {
    return AppleCalendarConnectionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarConnectionRequest>): AppleCalendarConnectionRequest {
    const message = createBaseAppleCalendarConnectionRequest();
    message.provider = object.provider ?? "";
    message.email = object.email ?? "";
    message.app_specific_password = object.app_specific_password ?? "";
    message.calendar_uri = object.calendar_uri ?? "";
    message.direction = object.direction ?? undefined;
    message.selected_calendar_uris = object.selected_calendar_uris?.map((e) => e) || [];
    return message;
  },
};

function createBaseAppleCalendarConnectionResponse(): AppleCalendarConnectionResponse {
  return { id: "", provider: "", email: "", status: "" };
}

export const AppleCalendarConnectionResponse: MessageFns<AppleCalendarConnectionResponse> = {
  encode(message: AppleCalendarConnectionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.email !== "") {
      writer.uint32(26).string(message.email);
    }
    if (message.status !== "") {
      writer.uint32(34).string(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarConnectionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarConnectionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.status = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarConnectionResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
    };
  },

  toJSON(message: AppleCalendarConnectionResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarConnectionResponse>): AppleCalendarConnectionResponse {
    return AppleCalendarConnectionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarConnectionResponse>): AppleCalendarConnectionResponse {
    const message = createBaseAppleCalendarConnectionResponse();
    message.id = object.id ?? "";
    message.provider = object.provider ?? "";
    message.email = object.email ?? "";
    message.status = object.status ?? "";
    return message;
  },
};

function createBaseCalendarConnectionListResponse(): CalendarConnectionListResponse {
  return { connections: [] };
}

export const CalendarConnectionListResponse: MessageFns<CalendarConnectionListResponse> = {
  encode(message: CalendarConnectionListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.connections) {
      CalendarConnection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalendarConnectionListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalendarConnectionListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.connections.push(CalendarConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalendarConnectionListResponse {
    return {
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => CalendarConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CalendarConnectionListResponse): unknown {
    const obj: any = {};
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => CalendarConnection.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CalendarConnectionListResponse>): CalendarConnectionListResponse {
    return CalendarConnectionListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CalendarConnectionListResponse>): CalendarConnectionListResponse {
    const message = createBaseCalendarConnectionListResponse();
    message.connections = object.connections?.map((e) => CalendarConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAppleCalendarManualSyncRequest(): AppleCalendarManualSyncRequest {
  return { id: "" };
}

export const AppleCalendarManualSyncRequest: MessageFns<AppleCalendarManualSyncRequest> = {
  encode(message: AppleCalendarManualSyncRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarManualSyncRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarManualSyncRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarManualSyncRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: AppleCalendarManualSyncRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarManualSyncRequest>): AppleCalendarManualSyncRequest {
    return AppleCalendarManualSyncRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarManualSyncRequest>): AppleCalendarManualSyncRequest {
    const message = createBaseAppleCalendarManualSyncRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseAppleCalendarSyncResponse(): AppleCalendarSyncResponse {
  return { status: "", inserted: 0, updated: 0, deleted: 0, last_sync: "", delta: undefined };
}

export const AppleCalendarSyncResponse: MessageFns<AppleCalendarSyncResponse> = {
  encode(message: AppleCalendarSyncResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.inserted !== 0) {
      writer.uint32(16).int32(message.inserted);
    }
    if (message.updated !== 0) {
      writer.uint32(24).int32(message.updated);
    }
    if (message.deleted !== 0) {
      writer.uint32(32).int32(message.deleted);
    }
    if (message.last_sync !== "") {
      writer.uint32(42).string(message.last_sync);
    }
    if (message.delta !== undefined) {
      CalendarConnectionDelta.encode(message.delta, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarSyncResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarSyncResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.inserted = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.updated = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.deleted = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.last_sync = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.delta = CalendarConnectionDelta.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarSyncResponse {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      inserted: isSet(object.inserted) ? globalThis.Number(object.inserted) : 0,
      updated: isSet(object.updated) ? globalThis.Number(object.updated) : 0,
      deleted: isSet(object.deleted) ? globalThis.Number(object.deleted) : 0,
      last_sync: isSet(object.last_sync) ? globalThis.String(object.last_sync) : "",
      delta: isSet(object.delta) ? CalendarConnectionDelta.fromJSON(object.delta) : undefined,
    };
  },

  toJSON(message: AppleCalendarSyncResponse): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.inserted !== 0) {
      obj.inserted = Math.round(message.inserted);
    }
    if (message.updated !== 0) {
      obj.updated = Math.round(message.updated);
    }
    if (message.deleted !== 0) {
      obj.deleted = Math.round(message.deleted);
    }
    if (message.last_sync !== "") {
      obj.last_sync = message.last_sync;
    }
    if (message.delta !== undefined) {
      obj.delta = CalendarConnectionDelta.toJSON(message.delta);
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarSyncResponse>): AppleCalendarSyncResponse {
    return AppleCalendarSyncResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarSyncResponse>): AppleCalendarSyncResponse {
    const message = createBaseAppleCalendarSyncResponse();
    message.status = object.status ?? "";
    message.inserted = object.inserted ?? 0;
    message.updated = object.updated ?? 0;
    message.deleted = object.deleted ?? 0;
    message.last_sync = object.last_sync ?? "";
    message.delta = (object.delta !== undefined && object.delta !== null)
      ? CalendarConnectionDelta.fromPartial(object.delta)
      : undefined;
    return message;
  },
};

function createBaseAppleCalendarDisconnectRequest(): AppleCalendarDisconnectRequest {
  return { id: "" };
}

export const AppleCalendarDisconnectRequest: MessageFns<AppleCalendarDisconnectRequest> = {
  encode(message: AppleCalendarDisconnectRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppleCalendarDisconnectRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppleCalendarDisconnectRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppleCalendarDisconnectRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: AppleCalendarDisconnectRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<AppleCalendarDisconnectRequest>): AppleCalendarDisconnectRequest {
    return AppleCalendarDisconnectRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppleCalendarDisconnectRequest>): AppleCalendarDisconnectRequest {
    const message = createBaseAppleCalendarDisconnectRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGoogleCalendarWebhookRequest(): GoogleCalendarWebhookRequest {
  return { payload: "" };
}

export const GoogleCalendarWebhookRequest: MessageFns<GoogleCalendarWebhookRequest> = {
  encode(message: GoogleCalendarWebhookRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.payload !== "") {
      writer.uint32(10).string(message.payload);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleCalendarWebhookRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleCalendarWebhookRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.payload = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleCalendarWebhookRequest {
    return { payload: isSet(object.payload) ? globalThis.String(object.payload) : "" };
  },

  toJSON(message: GoogleCalendarWebhookRequest): unknown {
    const obj: any = {};
    if (message.payload !== "") {
      obj.payload = message.payload;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleCalendarWebhookRequest>): GoogleCalendarWebhookRequest {
    return GoogleCalendarWebhookRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleCalendarWebhookRequest>): GoogleCalendarWebhookRequest {
    const message = createBaseGoogleCalendarWebhookRequest();
    message.payload = object.payload ?? "";
    return message;
  },
};

function createBaseGoogleCalendarWebhookResponse(): GoogleCalendarWebhookResponse {
  return { status: "" };
}

export const GoogleCalendarWebhookResponse: MessageFns<GoogleCalendarWebhookResponse> = {
  encode(message: GoogleCalendarWebhookResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleCalendarWebhookResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleCalendarWebhookResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleCalendarWebhookResponse {
    return { status: isSet(object.status) ? globalThis.String(object.status) : "" };
  },

  toJSON(message: GoogleCalendarWebhookResponse): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleCalendarWebhookResponse>): GoogleCalendarWebhookResponse {
    return GoogleCalendarWebhookResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleCalendarWebhookResponse>): GoogleCalendarWebhookResponse {
    const message = createBaseGoogleCalendarWebhookResponse();
    message.status = object.status ?? "";
    return message;
  },
};

function createBaseGoogleCalendar(): GoogleCalendar {
  return { id: "", summary: "", primary: false, background_color: undefined };
}

export const GoogleCalendar: MessageFns<GoogleCalendar> = {
  encode(message: GoogleCalendar, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.summary !== "") {
      writer.uint32(18).string(message.summary);
    }
    if (message.primary !== false) {
      writer.uint32(24).bool(message.primary);
    }
    if (message.background_color !== undefined) {
      writer.uint32(34).string(message.background_color);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleCalendar {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleCalendar();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.primary = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.background_color = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleCalendar {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
      primary: isSet(object.primary) ? globalThis.Boolean(object.primary) : false,
      background_color: isSet(object.background_color) ? globalThis.String(object.background_color) : undefined,
    };
  },

  toJSON(message: GoogleCalendar): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.summary !== "") {
      obj.summary = message.summary;
    }
    if (message.primary !== false) {
      obj.primary = message.primary;
    }
    if (message.background_color !== undefined) {
      obj.background_color = message.background_color;
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleCalendar>): GoogleCalendar {
    return GoogleCalendar.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleCalendar>): GoogleCalendar {
    const message = createBaseGoogleCalendar();
    message.id = object.id ?? "";
    message.summary = object.summary ?? "";
    message.primary = object.primary ?? false;
    message.background_color = object.background_color ?? undefined;
    return message;
  },
};

function createBaseGoogleCalendarListResponse(): GoogleCalendarListResponse {
  return { items: [] };
}

export const GoogleCalendarListResponse: MessageFns<GoogleCalendarListResponse> = {
  encode(message: GoogleCalendarListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      GoogleCalendar.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleCalendarListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoogleCalendarListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(GoogleCalendar.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoogleCalendarListResponse {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => GoogleCalendar.fromJSON(e)) : [],
    };
  },

  toJSON(message: GoogleCalendarListResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => GoogleCalendar.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GoogleCalendarListResponse>): GoogleCalendarListResponse {
    return GoogleCalendarListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GoogleCalendarListResponse>): GoogleCalendarListResponse {
    const message = createBaseGoogleCalendarListResponse();
    message.items = object.items?.map((e) => GoogleCalendar.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateCalendarConnectionSelectionRequest(): UpdateCalendarConnectionSelectionRequest {
  return { id: "", selected_ids: [] };
}

export const UpdateCalendarConnectionSelectionRequest: MessageFns<UpdateCalendarConnectionSelectionRequest> = {
  encode(message: UpdateCalendarConnectionSelectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.selected_ids) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCalendarConnectionSelectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCalendarConnectionSelectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.selected_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCalendarConnectionSelectionRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      selected_ids: globalThis.Array.isArray(object?.selected_ids)
        ? object.selected_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: UpdateCalendarConnectionSelectionRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.selected_ids?.length) {
      obj.selected_ids = message.selected_ids;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCalendarConnectionSelectionRequest>): UpdateCalendarConnectionSelectionRequest {
    return UpdateCalendarConnectionSelectionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCalendarConnectionSelectionRequest>): UpdateCalendarConnectionSelectionRequest {
    const message = createBaseUpdateCalendarConnectionSelectionRequest();
    message.id = object.id ?? "";
    message.selected_ids = object.selected_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseSubcalendar(): Subcalendar {
  return {
    id: "",
    connection_id: "",
    provider: "",
    external_id: "",
    display_name: "",
    color: "",
    enabled: false,
    assigned_owner_id: "",
    created_at: undefined,
    updated_at: undefined,
  };
}

export const Subcalendar: MessageFns<Subcalendar> = {
  encode(message: Subcalendar, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.connection_id !== "") {
      writer.uint32(18).string(message.connection_id);
    }
    if (message.provider !== "") {
      writer.uint32(26).string(message.provider);
    }
    if (message.external_id !== "") {
      writer.uint32(34).string(message.external_id);
    }
    if (message.display_name !== "") {
      writer.uint32(42).string(message.display_name);
    }
    if (message.color !== "") {
      writer.uint32(50).string(message.color);
    }
    if (message.enabled !== false) {
      writer.uint32(56).bool(message.enabled);
    }
    if (message.assigned_owner_id !== "") {
      writer.uint32(66).string(message.assigned_owner_id);
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(74).fork()).join();
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Subcalendar {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubcalendar();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connection_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.external_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.color = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.assigned_owner_id = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Subcalendar {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      connection_id: isSet(object.connection_id) ? globalThis.String(object.connection_id) : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      external_id: isSet(object.external_id) ? globalThis.String(object.external_id) : "",
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      color: isSet(object.color) ? globalThis.String(object.color) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      assigned_owner_id: isSet(object.assigned_owner_id) ? globalThis.String(object.assigned_owner_id) : "",
      created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : undefined,
      updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : undefined,
    };
  },

  toJSON(message: Subcalendar): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.connection_id !== "") {
      obj.connection_id = message.connection_id;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.external_id !== "") {
      obj.external_id = message.external_id;
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.color !== "") {
      obj.color = message.color;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.assigned_owner_id !== "") {
      obj.assigned_owner_id = message.assigned_owner_id;
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at;
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at;
    }
    return obj;
  },

  create(base?: DeepPartial<Subcalendar>): Subcalendar {
    return Subcalendar.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Subcalendar>): Subcalendar {
    const message = createBaseSubcalendar();
    message.id = object.id ?? "";
    message.connection_id = object.connection_id ?? "";
    message.provider = object.provider ?? "";
    message.external_id = object.external_id ?? "";
    message.display_name = object.display_name ?? "";
    message.color = object.color ?? "";
    message.enabled = object.enabled ?? false;
    message.assigned_owner_id = object.assigned_owner_id ?? "";
    message.created_at = object.created_at ?? undefined;
    message.updated_at = object.updated_at ?? undefined;
    return message;
  },
};

function createBaseListSubcalendarsRequest(): ListSubcalendarsRequest {
  return { connection_id: "" };
}

export const ListSubcalendarsRequest: MessageFns<ListSubcalendarsRequest> = {
  encode(message: ListSubcalendarsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.connection_id !== "") {
      writer.uint32(10).string(message.connection_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSubcalendarsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListSubcalendarsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.connection_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListSubcalendarsRequest {
    return { connection_id: isSet(object.connection_id) ? globalThis.String(object.connection_id) : "" };
  },

  toJSON(message: ListSubcalendarsRequest): unknown {
    const obj: any = {};
    if (message.connection_id !== "") {
      obj.connection_id = message.connection_id;
    }
    return obj;
  },

  create(base?: DeepPartial<ListSubcalendarsRequest>): ListSubcalendarsRequest {
    return ListSubcalendarsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListSubcalendarsRequest>): ListSubcalendarsRequest {
    const message = createBaseListSubcalendarsRequest();
    message.connection_id = object.connection_id ?? "";
    return message;
  },
};

function createBaseSubcalendarListResponse(): SubcalendarListResponse {
  return { subcalendars: [] };
}

export const SubcalendarListResponse: MessageFns<SubcalendarListResponse> = {
  encode(message: SubcalendarListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.subcalendars) {
      Subcalendar.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubcalendarListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubcalendarListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.subcalendars.push(Subcalendar.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubcalendarListResponse {
    return {
      subcalendars: globalThis.Array.isArray(object?.subcalendars)
        ? object.subcalendars.map((e: any) => Subcalendar.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SubcalendarListResponse): unknown {
    const obj: any = {};
    if (message.subcalendars?.length) {
      obj.subcalendars = message.subcalendars.map((e) => Subcalendar.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<SubcalendarListResponse>): SubcalendarListResponse {
    return SubcalendarListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubcalendarListResponse>): SubcalendarListResponse {
    const message = createBaseSubcalendarListResponse();
    message.subcalendars = object.subcalendars?.map((e) => Subcalendar.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateSubcalendarRequest(): UpdateSubcalendarRequest {
  return { id: "", enabled: undefined, color: undefined, assigned_owner_id: undefined };
}

export const UpdateSubcalendarRequest: MessageFns<UpdateSubcalendarRequest> = {
  encode(message: UpdateSubcalendarRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.enabled !== undefined) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.color !== undefined) {
      writer.uint32(26).string(message.color);
    }
    if (message.assigned_owner_id !== undefined) {
      writer.uint32(34).string(message.assigned_owner_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSubcalendarRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSubcalendarRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.color = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.assigned_owner_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSubcalendarRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : undefined,
      color: isSet(object.color) ? globalThis.String(object.color) : undefined,
      assigned_owner_id: isSet(object.assigned_owner_id) ? globalThis.String(object.assigned_owner_id) : undefined,
    };
  },

  toJSON(message: UpdateSubcalendarRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.enabled !== undefined) {
      obj.enabled = message.enabled;
    }
    if (message.color !== undefined) {
      obj.color = message.color;
    }
    if (message.assigned_owner_id !== undefined) {
      obj.assigned_owner_id = message.assigned_owner_id;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateSubcalendarRequest>): UpdateSubcalendarRequest {
    return UpdateSubcalendarRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateSubcalendarRequest>): UpdateSubcalendarRequest {
    const message = createBaseUpdateSubcalendarRequest();
    message.id = object.id ?? "";
    message.enabled = object.enabled ?? undefined;
    message.color = object.color ?? undefined;
    message.assigned_owner_id = object.assigned_owner_id ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
